import {authClient} from '~/lib/auth-client'

export const useAuth = () => {
  const config = useRuntimeConfig()
  const authBaseUrl = config.public.authBaseUrl
  // Invoke the hook here so it creates the reactive state properly
  const session = authClient.useSession()

  return {
    authClient,

    // Expose the reactive session state to your components
    session,

    // Auth methods safely mapped with full argument handling (...args)
    signIn: (...args: Parameters<typeof authClient.signIn.email>) => authClient.signIn.email(...args),

    signUp: (...args: Parameters<typeof authClient.signUp.email>) => authClient.signUp.email(...args),

    signOut: (...args: Parameters<typeof authClient.signOut>) => authClient.signOut(...args),

    magicLink: (...args: Parameters<typeof authClient.signIn.magicLink>) => authClient.signIn.magicLink(...args),

    sendOtp: (...args: Parameters<typeof authClient.emailOtp.sendVerificationOtp>) =>
      authClient.emailOtp.sendVerificationOtp(...args),

    verifyEmail: (...args: Parameters<typeof authClient.verifyEmail>) => authClient.verifyEmail(...args),

    sendVerificationEmail: (...args: Parameters<typeof authClient.sendVerificationEmail>) =>
      authClient.sendVerificationEmail(...args),

    resetPassword: (...args: Parameters<typeof authClient.resetPassword>) => authClient.resetPassword(...args),

    requestPasswordReset: (...args: Parameters<typeof authClient.requestPasswordReset>) =>
      authClient.requestPasswordReset(...args),

    verifyInvitation: async (invitationId: string) => {
      try {
        const url = `${authBaseUrl}/api/invitations/verify?id=${invitationId}`
        console.log('url::' + url)
        const response = await fetch(url)

        // Grab the text first to debug what is actually coming back
        const text = await response.text()

        let data
        try {
          data = JSON.parse(text)
        } catch (e) {
          console.error('Failed to parse JSON response:', text)
          throw new Error('Server returned an invalid response format.')
        }

        if (!response.ok) {
          throw new Error(data.error || 'Failed to verify invitation')
        }

        return data as {email: string; organizationId: string}
      } catch (err: any) {
        console.error('verifyInvitation error:')
        console.error('verifyInvitation error:', err)
        throw err
      }
    },

    allowAccess: async (userId: string) => {
      try {
        const url = `${authBaseUrl}/api/application/allowaccess?userId=${userId}&origin=${window.location.origin}`
        console.log('url::' + url)
        const response = await fetch(url)

        // Grab the text first to debug what is actually coming back
        const text = await response.text()

        let data
        try {
          data = JSON.parse(text)
        } catch (e) {
          console.error('Failed to parse JSON response:', text)
          throw new Error('Server returned an invalid response format.')
        }

        if (!response.ok) {
          throw new Error(data.error || 'Failed to verify invitation')
        }

        return data as {success: boolean; orgId: string}
      } catch (err: any) {
        console.error('allowAccess error:')
        console.error('allowAccess error:', err)
        throw err
      }
    },
    // Fully wrapped emailOtp namespace matching the latest API signatures
    emailOtp: {
      sendVerificationOtp: (...args: Parameters<typeof authClient.emailOtp.sendVerificationOtp>) =>
        authClient.emailOtp.sendVerificationOtp(...args),

      checkVerificationOtp: (...args: Parameters<typeof authClient.emailOtp.checkVerificationOtp>) =>
        authClient.emailOtp.checkVerificationOtp(...args),

      verifyEmail: (...args: Parameters<typeof authClient.emailOtp.verifyEmail>) =>
        authClient.emailOtp.verifyEmail(...args)
    },

    organization: {
      create: (...args: Parameters<typeof authClient.organization.create>) => authClient.organization.create(...args),

      inviteMember: (...args: Parameters<typeof authClient.organization.inviteMember>) =>
        authClient.organization.inviteMember(...args),

      acceptInvitation: (...args: Parameters<typeof authClient.organization.acceptInvitation>) =>
        authClient.organization.acceptInvitation(...args),

      rejectInvitation: (...args: Parameters<typeof authClient.organization.rejectInvitation>) =>
        authClient.organization.rejectInvitation(...args),

      cancelInvitation: (...args: Parameters<typeof authClient.organization.cancelInvitation>) =>
        authClient.organization.cancelInvitation(...args),

      listInvitations: (...args: Parameters<typeof authClient.organization.listInvitations>) =>
        authClient.organization.listInvitations(...args),

      getInvitation: (...args: Parameters<typeof authClient.organization.getInvitation>) =>
        authClient.organization.getInvitation(...args),
      hasPermission: (...args: Parameters<typeof authClient.organization.hasPermission>) =>
        authClient.organization.hasPermission(...args),

      checkRolePermission: (...args: Parameters<typeof authClient.organization.checkRolePermission>) =>
        authClient.organization.checkRolePermission(...args),

      list: (...args: Parameters<typeof authClient.organization.list>) => authClient.organization.list(...args)
    }
  }
}
